import React from "react";
import moment from "moment";
import { capitalizeFirstLetter } from "utils/capitalizeFirstLetter";
import arrangeEntriesByCategories from "utils/arrangeEntriesByCategories";
import findIndexByProperty from "utils/findIndexByProperty";
import findLockedEntryLetter from "utils/findLockedEntryLetter";
import sumTimeValues from "utils/sumTimeValues";
import calculateEntryStartTime from "utils/calculateEntryStartTime";
import GrandAwardEntry from "./GrandAwardEntry";

const GrandAwardCate = ({
  category,
  index,
  allEntries,
  sortedCategories,
  currentEvent,
  calculatePosition,
  calculateTotalScore,
  findMatchingAward,
  awards,
  allScores,
}) => {
  const myEntries = allEntries?.filter(
    (entry) => entry?.category_name === category?.category_name
  );
  const myEntriesSorted = myEntries?.sort((a, b) => a?.sort_id - b?.sort_id);

  function removeDuplicates(array) {
    const uniqueArray = [];
    const seenObjects = new Set();

    for (const obj of array) {
      // Serialize the object to JSON to use it as a unique identifier
      const serializedObj = JSON.stringify(obj);

      if (!seenObjects.has(serializedObj)) {
        seenObjects.add(serializedObj);
        uniqueArray.push(obj);
      }
    }

    return uniqueArray;
  }

  //===============================================================================to calc dynamic entry count of all entries in routine
  const categories = sortedCategories?.filter((l) => l?.type === "category");

  const allEntriesWithoutLocked = arrangeEntriesByCategories(
    categories,
    allEntries
  )?.filter((k) => k?.locked_entry === false);

  const allEntriesWithLocked = arrangeEntriesByCategories(
    categories,
    allEntries
  );

  function entryCount(itm) {
    const allEntriesBeforeLocked = allEntriesWithLocked
      ?.slice(
        0,
        findIndexByProperty(allEntriesWithLocked, "doc_id", itm?.doc_id)
      )
      ?.filter((m) => m?.locked_entry === false);

    if (itm?.locked_entry) {
      return `${
        allEntriesBeforeLocked?.length === 0
          ? 1
          : allEntriesBeforeLocked?.length
      }${findLockedEntryLetter(allEntriesWithLocked, itm)}`;
    } else {
      return (
        findIndexByProperty(allEntriesWithoutLocked, "doc_id", itm?.doc_id) + 1
      );
    }
  }

  //============================================================================================new entry time calculation

  // to get all categories before current category
  const categoriesBeforeCurrent = sortedCategories?.slice(0, index) || [];

  const allBufferBeforeCurrent = categoriesBeforeCurrent?.filter(
    (cate) => cate?.type === "buffer"
  );
  const timeToAdd = allBufferBeforeCurrent?.reduce((sum, obj) => {
    if (obj.type === "buffer") {
      const bufferValue = Number(obj.buffer);
      if (!isNaN(bufferValue)) {
        return sum + bufferValue;
      }
    }
    return sum;
  }, 0);

  function addMinutesToTime(inputTime, minutesToAdd) {
    const timeMoment = moment(inputTime, "h:mm A");
    const endTime = timeMoment.clone().add(minutesToAdd, "minutes");
    const formattedEndTime = endTime.format("h:mm A");
    return formattedEndTime;
  }

  const startTime = currentEvent?.days[0]?.startTime;
  const initialTime = moment(startTime).utc().format("h:mm A");

  //to get the entry count of all entries in routine
  function entryTime(itm) {
    const idx = findIndexByProperty(
      removeDuplicates(allEntriesWithoutLocked),
      "doc_id",
      itm?.doc_id
    );
    if (idx === 0) {
      return addMinutesToTime(initialTime, timeToAdd);
    } else {
      const allEntriesBeforeCurrent = removeDuplicates(
        allEntriesWithoutLocked
      )?.slice(
        0,
        findIndexByProperty(
          removeDuplicates(allEntriesWithoutLocked),
          "doc_id",
          itm?.doc_id
        )
      );

      const allTimeBeforeCurrent = sumTimeValues(allEntriesBeforeCurrent);
      const startTime = calculateEntryStartTime(
        initialTime,
        allTimeBeforeCurrent,
        itm
      );

      return addMinutesToTime(startTime, timeToAdd);
    }
  }

  const sessionsBeforeCurrent = categoriesBeforeCurrent?.filter(
    (item) => item?.break_type === "session"
  );

  return (
    <div
      className={`relative ${
        (category?.type === "buffer" || category?.break_type === "break") &&
        "hidden"
      }  border-y border-white/10`}
    >
      {category?.is_scratched && (
        <div className="w-full h-full bg-stone-700/40 absolute top-0 left-0"></div>
      )}
      <div
        className={`w-full p-3 bg-[#282929] lg:text-center font-bold relative ${
          category?.type === "buffer"
            ? "bg-[#4f2d54]"
            : category?.break_type === "session"
            ? "bg-[#42125f]"
            : "bg-[#282929] "
        }`}
      >
        <h2
          className={`${
            category?.is_scratched ? "text-white/50" : "text-white"
          } flex gap-3 items-center md:justify-center`}
        >
          {category?.is_scratched && (
            <img alt="" src="/images/scratchCat.png" className="w-5 h-3" />
          )}
          {`${capitalizeFirstLetter(category?.category_name)}`}
          {category?.type === "category" && (
            <span className="ml-[0.25rem]">({myEntriesSorted?.length})</span>
          )}{" "}
          {/*========================================================================= to dynamically render overalls or grand award tags */}
          {category?.break_type?.includes("overalls_") && (
            <span className="">
              {category?.break_type?.split("_")[1] === "overall"
                ? "OVERALLS"
                : category?.break_type?.split("_")[1] === "grand"
                ? "GRAND OVERALLS"
                : "CUSTOM REPORT"}
            </span>
          )}
          {/* to dynamically render sessions count */}
          {category?.break_type === "session" && (
            <span className="">
              {" "}
              {sessionsBeforeCurrent?.length === 0
                ? 1
                : sessionsBeforeCurrent?.length + 1}
            </span>
          )}
        </h2>
      </div>
      {/* entries container */}
      <div className="w-full">
        {myEntriesSorted?.map((item, idx) => {
          return (
            <GrandAwardEntry
              key={idx}
              idx={idx}
              item={item}
              entryTime={entryTime}
              entryCount={entryCount}
              category={category}
              calculatePosition={calculatePosition}
              calculateTotalScore={calculateTotalScore}
              findMatchingAward={findMatchingAward}
              myEntries={myEntries}
              awards={awards}
              currentEvent={currentEvent}
              allScores={allScores}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GrandAwardCate;
